import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

function SubscriptionModal({
  open,
  onClose,
  setFrequency,
  frequency,
  state,
  setState,
  setSubscriptionBtn,
  sku,
  setSku,
}) {
  const handleApply = () => {
    // const filters = {
    //   frequency,
    //   sku,
    // };

    // setState()
    // onApply?.(filters);
    setSubscriptionBtn(true);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
    >
      <DialogTitle>Modify Filters</DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          mt={1}
        >
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={state}
              label="Status"
              onChange={(e) => setState(e.target.value)}
            >
              <MenuItem value="">
                <em>Any</em>
              </MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Frequency</InputLabel>
            <Select
              value={frequency}
              label="Frequency"
              onChange={(e) => setFrequency(e.target.value)}
            >
              <MenuItem value="">
                <em>Any</em>
              </MenuItem>
              <MenuItem value="daily">Daily</MenuItem>
              <MenuItem value="weekly">Weekly</MenuItem>
              <MenuItem value="biweekly">Biweekly</MenuItem>
              <MenuItem value="quadweekly">Quadweekly</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="SKU"
            value={sku}
            onChange={(e) => setSku(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleApply}
          variant="contained"
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SubscriptionModal;
